/* eslint-disable sort-keys */
import { envNames } from '../../utils/constants';
const { DEV, PROD, SANDBOX, STAGE } = envNames;

export const RMD_SUBJECT = 'Required Minimum Distribution (RMD)';

export const getFaqItem = (accountType = '', subject = '', env) => {
  const items =
    situationConfig[accountType] && situationConfig[accountType][subject];

  if (!items) return [];

  return items.map(item => ({
    label: item.faqItem,
    url: item[env === SANDBOX ? DEV : env]
  }));
};

const LIFE_EVENTS = 'Life Events';

export const getFAQSubText = (faqItems, selectedSubject) => {
  if (selectedSubject === LIFE_EVENTS) {
    return `Here is a handful of helpful links based on your account type and subject. <br/><br/>
      Life events can include birth, death, marriage, divorce and job changes.`;
  }
  return faqItems.length
    ? `Here is a handful of helpful links based on your account type and subject`
    : `Select your account type and subject to see answers to commonly asked questions`;
};

// eslint-disabled
export const situationConfig = {
  '10': {
    'Cost Basis': [
      {
        faqItem: 'View the cost basis summary for your account',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/taxes',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/taxes',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/taxes',
        product: 'Mutual Fund',
        subject: 'Cost Basis'
      },
      {
        faqItem: 'Update the cost basis method',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/cost-basis',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/cost-basis',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/cost-basis',
        product: 'Mutual Fund',
        subject: 'Cost Basis'
      },
      {
        faqItem: 'Learn more about cost basis',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/cost-basis-accounting-and-calculation.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/cost-basis-accounting-and-calculation.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/cost-basis-accounting-and-calculation.html',
        product: 'Mutual Fund',
        subject: 'Cost Basis'
      }
    ],
    'Dividend Distributions': [
      {
        faqItem:
          'View the T.\u00A0Rowe\u00A0Price funds dividend distributions',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/dividend-distributions.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/dividend-distributions.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/dividend-distributions.html',
        product: 'Mutual Fund',
        subject: 'Dividend Distributions'
      },
      {
        faqItem: 'View your transaction history',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/transactions',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/transactions',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/transactions',
        product: 'Mutual Fund',
        subject: 'Dividend Distributions'
      }
    ],
    Fees: [
      {
        faqItem: 'Fees and Minimums',
        [DEV]:
          'https://www.troweprice.com/personal-investing/help/fees-and-minimums.html?WTAFeaturedResult=fees',
        [PROD]:
          'https://www.troweprice.com/personal-investing/help/fees-and-minimums.html?WTAFeaturedResult=fees',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/help/fees-and-minimums.html?WTAFeaturedResult=fees',
        product: 'Mutual Fund',
        subject: 'Fees'
      }
    ],
    Forms: [
      {
        faqItem: 'Visit the Forms & Literature page',
        [DEV]: 'https://www.troweprice.com/personal-investing/forms.html',
        [PROD]: 'https://www.troweprice.com/personal-investing/forms.html',
        [STAGE]: 'https://www.troweprice.com/personal-investing/forms.html',
        product: 'Mutual Fund',
        subject: 'Forms'
      }
    ],
    'Individual Retirement Account (IRA)': [
      {
        faqItem: 'IRA Contribution History',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/taxes',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/taxes',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/taxes',
        product: 'Mutual Fund',
        subject: 'Individual Retirement Account (IRA)'
      },
      {
        faqItem: "IRA Limits & Other FAQ's",
        [DEV]:
          'https://www.troweprice.com/personal-investing/retirement/ira.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/retirement/ira.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/retirement/ira.html',
        product: 'Mutual Fund',
        subject: 'Individual Retirement Account (IRA)'
      }
    ],
    'Required Minimum Distribution (RMD)': [
      {
        faqItem: 'View your automatic IRA withdrawal agreement',
        [DEV]: 'https://wwwdev.troweprice.com/usis/transactions/automatic',
        [PROD]: 'https://www.troweprice.com/usis/transactions/automatic',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/transactions/automatic',
        product: 'Mutual Fund',
        subject: 'Required Minimum Distribution (RMD)'
      },
      {
        faqItem:
          'Update your tax withholding election on your automatic IRA withdrawal agreement',
        [DEV]: 'https://wwwdev.troweprice.com/usis/transactions/automatic',
        [PROD]: 'https://www.troweprice.com/usis/transactions/automatic',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/transactions/automatic',
        product: 'Mutual Fund',
        subject: 'Required Minimum Distribution (RMD)'
      },
      {
        faqItem: 'Visit our RMD Learning Center',
        [DEV]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/retirement-planning/living-in-retirement/rmds.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/retirement-planning/living-in-retirement/rmds.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/retirement-planning/living-in-retirement/rmds.html',
        product: 'Mutual Fund',
        subject: 'Required Minimum Distribution (RMD)'
      },
      {
        faqItem: 'View your RMD calculation',
        [DEV]: 'https://wwwdev.troweprice.com/usis/rmd-tool/',
        [PROD]: 'https://www.troweprice.com/usis/rmd-tool/',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/rmd-tool/',
        product: 'Mutual Fund',
        subject: 'Required Minimum Distribution (RMD)'
      }
    ],
    'Tax Information and Forms': [
      {
        faqItem: 'View the tax form mailing schedule',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        product: 'Mutual Fund',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View or print your tax forms',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/statements',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/statements',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/statements',
        product: 'Mutual Fund',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Learn why you may or may not receive a tax form',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        product: 'Mutual Fund',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View the tax summary for your account',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/taxes',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/taxes',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/taxes',
        product: 'Mutual Fund',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Visit our Tax Planning Center',
        [DEV]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        product: 'Mutual Fund',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View other FAQs about taxes',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes.html',
        product: 'Mutual Fund',
        subject: 'Tax Information and Forms'
      }
    ],
    Transactions: [
      {
        faqItem: 'Set up automatic transactions',
        [DEV]: 'https://wwwdev.troweprice.com/usis/transactions/automatic',
        [PROD]: 'https://www.troweprice.com/usis/transactions/automatic',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/transactions/automatic',
        product: 'Mutual Fund',
        subject: 'Transactions'
      },
      {
        faqItem: 'Learn how to rollover your IRA to T.\u00A0Rowe\u00A0Price',
        [DEV]:
          'https://www.troweprice.com/personal-investing/retirement/ira/rollover-and-transfer-ira.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/retirement/ira/rollover-and-transfer-ira.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/retirement/ira/rollover-and-transfer-ira.html',
        product: 'Mutual Fund',
        subject: 'Transactions'
      },
      {
        faqItem: 'Submit a mutual fund buy transaction',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/buy?productType=MutualFund',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/buy?productType=MutualFund',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/buy?productType=MutualFund',
        product: 'Mutual Fund',
        subject: 'Transactions'
      },
      {
        faqItem: 'Submit a mutual fund sell transaction',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/sell?productType=MutualFund',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/sell?productType=MutualFund',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/sell?productType=MutualFund',
        product: 'Mutual Fund',
        subject: 'Transactions'
      },
      {
        faqItem: 'Learn about T.\u00A0Rowe\u00A0Price fees and minimums',
        [DEV]:
          'https://www.troweprice.com/personal-investing/help/fees-and-minimums.html?tab=2',
        [PROD]:
          'https://www.troweprice.com/personal-investing/help/fees-and-minimums.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/help/fees-and-minimums.html?tab=4',
        product: 'Mutual Fund',
        subject: 'Transactions'
      },
      {
        faqItem: 'Learn about online trading limitations',
        [DEV]:
          'https://www.troweprice.com/personal-investing/help/transactions.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/help/transactions.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/help/transactions.html',
        product: 'Mutual Fund',
        subject: 'Transactions'
      },
      {
        faqItem: 'Qualified Charitable Distributions (QCDs)',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/qcd/landing',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/qcd/landing',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/qcd/landing',
        product: 'Mutual Fund',
        subject: 'Transactions'
      }
    ],
    'Update Account Information': [
      {
        faqItem: 'Change Beneficiary information online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/beneficiaries',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/beneficiaries',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/beneficiaries',
        product: 'Mutual Fund',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Update Paperless Preferences online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/document-delivery',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/document-delivery',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/document-delivery',
        product: 'Mutual Fund',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Change your password online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [PROD]:
          'https://www.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        product: 'Mutual Fund',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Add/Update Bank information online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        product: 'Mutual Fund',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Change your name',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/contact-information',
        [PROD]:
          'https://individual.troweprice.com/staticFiles/Retail/Shared/PDFs/namechange.pdf',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/contact-information',
        product: 'Mutual Fund',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Update your address online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/contact-information',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/contact-information',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/contact-information',
        product: 'Mutual Fund',
        subject: 'Update Account Information'
      }
    ],
    'Life Events': [
      {
        faqItem:
          'Learn about life events and how they may impact your investing strategy',
        [DEV]:
          'https://wwwdev.troweprice.com/personal-investing/resources/planning/life-events/index.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/resources/planning/life-events/index.html',
        [STAGE]:
          'https://wwwstage.troweprice.com/personal-investing/resources/planning/life-events/index.html',
        product: 'Mutual Fund',
        subject: 'Life Events'
      }
    ]
  },
  '110': {
    Fees: [
      {
        faqItem: 'Fees and Minimums',
        [DEV]:
          'https://wwwdev.troweprice.com/personal-investing/advice/activeplus-portfolios/index.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice/activeplus-portfolios/index.html',
        [STAGE]:
          'https://wwwstage.troweprice.com/personal-investing/advice/activeplus-portfolios/index.html',
        product: 'APP',
        subject: 'Fees'
      }
    ],
    RMD_SUBJECT: [
      {
        faqItem: 'View your automatic IRA withdrawal agreement',
        [DEV]: 'https://wwwdev.troweprice.com/usis/transactions/automatic',
        [PROD]: 'https://www.troweprice.com/usis/transactions/automatic',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/transactions/automatic',
        product: 'APP',
        subject: RMD_SUBJECT
      },
      {
        faqItem:
          'Update your tax withholding election on your automatic IRA withdrawal agreement',
        [DEV]: 'https://wwwdev.troweprice.com/usis/transactions/automatic',
        [PROD]: 'https://www.troweprice.com/usis/transactions/automatic',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/transactions/automatic',
        product: 'APP',
        subject: RMD_SUBJECT
      },
      {
        faqItem: 'Visit our RMD Learning Center',
        [DEV]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/retirement-planning/living-in-retirement/rmds.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/retirement-planning/living-in-retirement/rmds.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/retirement-planning/living-in-retirement/rmds.html',
        product: 'APP',
        subject: RMD_SUBJECT
      },
      {
        faqItem: 'View your RMD calculation',
        [DEV]: 'https://www.troweprice.com/usis/rmd-tool/',
        [PROD]: 'https://www.troweprice.com/usis/rmd-tool/',
        [STAGE]: 'https://www.troweprice.com/usis/rmd-tool/',
        product: 'APP',
        subject: RMD_SUBJECT
      }
    ],
    Forms: [
      {
        faqItem: 'Visit the Forms & Literature page',
        [DEV]: 'https://www.troweprice.com/personal-investing/forms.html',
        [PROD]: 'https://www.troweprice.com/personal-investing/forms.html',
        [STAGE]: 'https://www.troweprice.com/personal-investing/forms.html',
        product: 'APP',
        subject: 'Forms'
      }
    ],
    'Individual Retirement Account (IRA)': [
      {
        faqItem: 'IRA Contribution History',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/taxes',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/taxes',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/taxes',
        product: 'APP',
        subject: 'Individual Retirement Account (IRA)'
      },
      {
        faqItem: "IRA Limits & Other FAQ's",
        [DEV]:
          'https://www.troweprice.com/personal-investing/retirement/ira.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/retirement/ira.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/retirement/ira.html',
        product: 'APP',
        subject: 'Individual Retirement Account (IRA)'
      }
    ],
    'Tax Information and Forms': [
      {
        faqItem: 'View the tax form mailing schedule',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        product: 'APP',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View or print your tax forms',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/statements',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/statements',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/statements',
        product: 'APP',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Learn why you may or may not receive a tax form',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        product: 'APP',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Visit our Tax Planning Center',
        [DEV]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        product: 'APP',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View other FAQs about taxes',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes.html',
        product: 'APP',
        subject: 'Tax Information and Forms'
      }
    ],
    Transactions: [
      {
        faqItem: 'Learn how to rollover your IRA to T.\u00A0Rowe\u00A0Price',
        [DEV]:
          'https://www.troweprice.com/personal-investing/retirement/ira/rollover-and-transfer-ira.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/retirement/ira/rollover-and-transfer-ira.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/retirement/ira/rollover-and-transfer-ira.html',
        product: 'APP',
        subject: 'Transactions'
      },
      {
        faqItem: 'Learn about online trading limitations',
        [DEV]:
          'https://www.troweprice.com/personal-investing/help/transactions.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/help/transactions.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/help/transactions.html',
        product: 'APP',
        subject: 'Transactions'
      },
      {
        faqItem: 'Add money into an ActivePlus Portfolio',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/advisory/add',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/advisory/add',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/advisory/add',
        product: 'APP',
        subject: 'Transactions'
      },
      {
        faqItem: 'Withdraw money from an ActivePlus Portfolio',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/advisory/withdraw',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/advisory/withdraw',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/advisory/withdraw',
        product: 'APP',
        subject: 'Transactions'
      },
      {
        faqItem: 'Qualified Charitable Distributions (QCDs)',
        [DEV]:
          'https://www.troweprice.com/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf',
        [PROD]:
          'https://www.troweprice.com/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf',
        [STAGE]:
          'https://www.troweprice.com/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf',
        product: 'APP',
        subject: 'Transactions'
      }
    ],
    'Update Account Information': [
      {
        faqItem: 'Change Beneficiary information online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/beneficiaries',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/beneficiaries',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/beneficiaries',
        product: 'APP',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Update Paperless Preferences online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/document-delivery',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/document-delivery',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/document-delivery',
        product: 'APP',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Change your password online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [PROD]:
          'https://www.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        product: 'APP',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Add/Update Bank information online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        product: 'APP',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Change your name',
        [DEV]:
          'https://wwwdev.troweprice.com/content/dam/iinvestor/Forms/namechange.pdf',
        [PROD]:
          'https://www.troweprice.com/content/dam/iinvestor/Forms/namechange.pdf',
        [STAGE]:
          'https://wwwstage.troweprice.com/content/dam/iinvestor/Forms/namechange.pdf',
        product: 'APP',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Update your address online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/contact-information',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/contact-information',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/contact-information',
        product: 'APP',
        subject: 'Update Account Information'
      }
    ],
    'Life Events': [
      {
        faqItem:
          'Learn about life events and how they may impact your investing strategy',
        [DEV]:
          'https://wwwdev.troweprice.com/personal-investing/resources/planning/life-events/index.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/resources/planning/life-events/index.html',
        [STAGE]:
          'https://wwwstage.troweprice.com/personal-investing/resources/planning/life-events/index.html',
        product: 'APP',
        subject: 'Life Events'
      }
    ]
  },
  '20': {
    'Cost Basis': [
      {
        faqItem: 'View the cost basis summary for your account',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/taxes',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/taxes',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/taxes',
        product: 'Brokerage',
        subject: 'Cost Basis'
      },
      {
        faqItem: 'Update the cost basis method',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/cost-basis',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/cost-basis',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/cost-basis',
        product: 'Brokerage',
        subject: 'Cost Basis'
      },
      {
        faqItem: 'Learn more about cost basis',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/cost-basis-accounting-and-calculation.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/cost-basis-accounting-and-calculation.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/cost-basis-accounting-and-calculation.html',
        product: 'Brokerage',
        subject: 'Cost Basis'
      }
    ],
    'Dividend Distributions': [
      {
        faqItem: 'View your transaction history',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/transactions',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/transactions',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/transactions',
        product: 'Brokerage',
        subject: 'Dividend Distributions'
      }
    ],
    Fees: [
      {
        faqItem: 'Fees and Minimums',
        [DEV]:
          'https://www.troweprice.com/personal-investing/help/fees-and-minimums.html?WTAFeaturedResult=fees',
        [PROD]:
          'https://www.troweprice.com/personal-investing/help/fees-and-minimums.html?WTAFeaturedResult=fees',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/help/fees-and-minimums.html?WTAFeaturedResult=fees',
        product: 'Brokerage',
        subject: 'Fees'
      }
    ],
    Forms: [
      {
        faqItem: 'Visit the Forms & Literature page',
        [DEV]: 'https://www.troweprice.com/personal-investing/forms.html',
        [PROD]: 'https://www.troweprice.com/personal-investing/forms.html',
        [STAGE]: 'https://www.troweprice.com/personal-investing/forms.html',
        product: 'Brokerage',
        subject: 'Forms'
      }
    ],
    'Individual Retirement Account (IRA)': [
      {
        faqItem: 'IRA Contribution History',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/taxes',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/taxes',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/taxes',
        product: 'Brokerage',
        subject: 'Individual Retirement Account (IRA)'
      },
      {
        faqItem: "IRA Limits & Other FAQ's",
        [DEV]:
          'https://www.troweprice.com/personal-investing/retirement/ira.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/retirement/ira.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/retirement/ira.html',
        product: 'Brokerage',
        subject: 'Individual Retirement Account (IRA)'
      }
    ],
    'Required Minimum Distribution (RMD)': [
      {
        faqItem: 'View your automatic IRA withdrawal agreement',
        [DEV]: 'https://wwwdev.troweprice.com/usis/transactions/automatic',
        [PROD]: 'https://www.troweprice.com/usis/transactions/automatic',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/transactions/automatic',
        product: 'Brokerage',
        subject: 'Required Minimum Distribution (RMD)'
      },
      {
        faqItem:
          'Update your tax withholding election on your automatic IRA withdrawal agreement',
        [DEV]: 'https://wwwdev.troweprice.com/usis/transactions/automatic',
        [PROD]: 'https://www.troweprice.com/usis/transactions/automatic',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/transactions/automatic',
        product: 'Brokerage',
        subject: 'Required Minimum Distribution (RMD)'
      },
      {
        faqItem: 'Visit our RMD Learning Center',
        [DEV]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/retirement-planning/living-in-retirement/rmds.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/retirement-planning/living-in-retirement/rmds.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/retirement-planning/living-in-retirement/rmds.html',
        product: 'Brokerage',
        subject: 'Required Minimum Distribution (RMD)'
      },
      {
        faqItem: 'View your RMD calculation',
        [DEV]: 'https://www.troweprice.com/usis/rmd-tool/',
        [PROD]: 'https://www.troweprice.com/usis/rmd-tool/',
        [STAGE]: 'https://www.troweprice.com/usis/rmd-tool/',
        product: 'Brokerage',
        subject: 'Required Minimum Distribution (RMD)'
      }
    ],
    'Tax Information and Forms': [
      {
        faqItem: 'View the tax form mailing schedule',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        product: 'Brokerage',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View or print your tax forms',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/statements',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/statements',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/statements',
        product: 'Brokerage',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Learn why you may or may not receive a tax form',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        product: 'Brokerage',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View the tax summary for your account',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/taxes',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/taxes',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/taxes',
        product: 'Brokerage',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Visit our Tax Planning Center',
        [DEV]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        product: 'Brokerage',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View other FAQs about taxes',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes.html',
        product: 'Brokerage',
        subject: 'Tax Information and Forms'
      }
    ],
    Transactions: [
      {
        faqItem: 'Learn how to enter a brokerage trade',
        [DEV]:
          'https://www.troweprice.com/personal-investing/help/brokerage-resource-center.html?tab=2',
        [PROD]:
          'https://www.troweprice.com/personal-investing/help/brokerage-resource-center.html?tab=2',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/help/brokerage-resource-center.html?tab=2',
        product: 'Brokerage',
        subject: 'Transactions'
      },
      {
        faqItem: 'Learn how to rollover your IRA to T.\u00A0Rowe\u00A0Price',
        [DEV]:
          'https://www.troweprice.com/personal-investing/retirement/ira/rollover-and-transfer-ira.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/retirement/ira/rollover-and-transfer-ira.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/retirement/ira/rollover-and-transfer-ira.html',
        product: 'Brokerage',
        subject: 'Transactions'
      },
      {
        faqItem: 'Learn about T.\u00A0Rowe\u00A0Price fees and minimums',
        [DEV]:
          'https://www.troweprice.com/personal-investing/help/fees-and-minimums.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/help/fees-and-minimums.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/help/fees-and-minimums.html',
        product: 'Brokerage',
        subject: 'Transactions'
      },
      {
        faqItem: 'Gift Requests',
        [DEV]:
          'https://individual.troweprice.com/Retail/Shared/PDFs/GiftTransferForm.pdf',
        [PROD]:
          'https://individual.troweprice.com/Retail/Shared/PDFs/GiftTransferForm.pdf',
        [STAGE]:
          'https://individual.troweprice.com/Retail/Shared/PDFs/GiftTransferForm.pdf',
        product: 'Brokerage',
        subject: 'Transactions'
      },
      {
        faqItem: 'Qualified Charitable Distributions (QCDs)',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/qcd/landing',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/qcd/landing',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/qcd/landing',
        product: 'Brokerage',
        subject: 'Transactions'
      }
    ],
    'Update Account Information': [
      {
        faqItem: 'Change Beneficiary information online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/beneficiaries',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/beneficiaries',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/beneficiaries',
        product: 'Brokerage',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Update Paperless Preferences online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/document-delivery',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/document-delivery',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/document-delivery',
        product: 'Brokerage',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Change your password online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [PROD]:
          'https://www.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        product: 'Brokerage',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Add/Update Bank information online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        product: 'Brokerage',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Change your name',
        [DEV]:
          'https://individualdev.troweprice.com/staticFiles/Retail/Shared/PDFs/namechange.pdf',
        [PROD]:
          'https://individual.troweprice.com/staticFiles/Retail/Shared/PDFs/namechange.pdf',
        [STAGE]:
          'https://individualqual.troweprice.com/staticFiles/Retail/Shared/PDFs/namechange.pdf',
        product: 'Brokerage',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Update your address online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/contact-information',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/contact-information',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/contact-information',
        product: 'Brokerage',
        subject: 'Update Account Information'
      }
    ],
    'Life Events': [
      {
        faqItem:
          'Learn about life events and how they may impact your investing strategy',
        [DEV]:
          'https://wwwdev.troweprice.com/personal-investing/resources/planning/life-events/index.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/resources/planning/life-events/index.html',
        [STAGE]:
          'https://wwwstage.troweprice.com/personal-investing/resources/planning/life-events/index.html',
        product: 'Brokerage',
        subject: 'Life Events'
      }
    ]
  },
  '40': {
    Forms: [
      {
        faqItem: 'Download a form',
        [DEV]:
          'https://maryland529.com/Forms#Maryland%20College%20Investment%20Plan%20Account',
        [PROD]:
          'https://maryland529.com/Forms#Maryland%20College%20Investment%20Plan%20Account',
        [STAGE]:
          'https://maryland529.com/Forms#Maryland%20College%20Investment%20Plan%20Account',
        product: '529 Plan',
        subject: 'Forms'
      }
    ],
    'Tax Information and Forms': [
      {
        faqItem: 'View the tax form mailing schedule',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View or print your tax forms',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/statements',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/statements',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/statements',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Learn why you may or may not receive a tax form',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View the tax summary for your account',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/taxes',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/taxes',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/taxes',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Visit our Tax Planning Center',
        [DEV]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View other FAQs about taxes',
        [DEV]: 'https://maryland529.com/Account-Holders/MCIP-FAQs',
        [PROD]: 'https://maryland529.com/Account-Holders/MCIP-FAQs',
        [STAGE]: 'https://maryland529.com/Account-Holders/MCIP-FAQs',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      }
    ],
    Transactions: [
      {
        faqItem: 'Contribute to a 529 portfolio',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/college/contribute',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/college/contribute',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/college/contribute',
        product: '529 Plan',
        subject: 'Transactions'
      },
      {
        faqItem: 'Take a distribution from a 529 portfolio',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/college/distribute',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/college/distribute',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/college/distribute',
        product: '529 Plan',
        subject: 'Transactions'
      },
      {
        faqItem: 'Set up automatic transactions',
        [DEV]: 'https://wwwdev.troweprice.com/usis/transactions/automatic',
        [PROD]: 'https://www.troweprice.com/usis/transactions/automatic',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/transactions/automatic',
        product: '529 Plan',
        subject: 'Transactions'
      },
      {
        faqItem: 'Qualified distribution or education expense',
        [DEV]:
          'https://maryland529.com/Account-Holders/benefits-and-distributions#Maryland%20College%20Investment%20Plan',
        [PROD]:
          'https://maryland529.com/Account-Holders/benefits-and-distributions#Maryland%20College%20Investment%20Plan',
        [STAGE]:
          'https://maryland529.com/Account-Holders/benefits-and-distributions#Maryland%20College%20Investment%20Plan',
        product: '529 Plan',
        subject: 'Transactions'
      }
    ],
    'Update Account Information': [
      {
        faqItem: 'Update Paperless Preferences online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/document-delivery',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/document-delivery',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/document-delivery',
        product: '529 Plan',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Change your password online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [PROD]:
          'https://www.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        product: '529 Plan',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Add/Update Bank information online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        product: '529 Plan',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Update your address online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/contact-information',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/contact-information',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/contact-information',
        product: '529 Plan',
        subject: 'Update Account Information'
      }
    ]
  },
  '70': {
    'Tax Information and Forms': [
      {
        faqItem: 'View the tax form mailing schedule',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View or print your tax forms',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/statements',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/statements',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/statements',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Learn why you may or may not receive a tax form',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View the tax summary for your account',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/taxes',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/taxes',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/taxes',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Visit our Tax Planning Center',
        [DEV]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View other FAQs about taxes',
        [DEV]:
          'https://www.alaska529plan.com/account-holder.html#distributions',
        [PROD]:
          'https://www.alaska529plan.com/account-holder.html#distributions',
        [STAGE]:
          'https://www.alaska529plan.com/account-holder.html#distributions',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      }
    ],
    Transactions: [
      {
        faqItem: 'Contribute to a 529 portfolio',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/college/contribute',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/college/contribute',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/college/contribute',
        product: '529 Plan',
        subject: 'Transactions'
      },
      {
        faqItem: 'Take a distribution from a 529 portfolio',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/college/distribute',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/college/distribute',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/college/distribute',
        product: '529 Plan',
        subject: 'Transactions'
      },
      {
        faqItem: 'Set up automatic transactions',
        [DEV]: 'https://wwwdev.troweprice.com/usis/transactions/automatic',
        [PROD]: 'https://www.troweprice.com/usis/transactions/automatic',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/transactions/automatic',
        product: '529 Plan',
        subject: 'Transactions'
      },
      {
        faqItem: 'Qualified distribution or education expense',
        [DEV]:
          'https://www.alaska529plan.com/account-holder.html#distributions',
        [PROD]:
          'https://www.alaska529plan.com/account-holder.html#distributions',
        [STAGE]:
          'https://www.alaska529plan.com/account-holder.html#distributions',
        product: '529 Plan',
        subject: 'Transactions'
      }
    ],
    'Update Account Information': [
      {
        faqItem: 'Update Paperless Preferences online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/document-delivery',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/document-delivery',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/document-delivery',
        product: '529 Plan',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Change your password online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [PROD]:
          'https://www.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        product: '529 Plan',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Add/Update Bank information online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        product: '529 Plan',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Update your address online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/contact-information',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/contact-information',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/contact-information',
        product: '529 Plan',
        subject: 'Update Account Information'
      }
    ],
    Forms: [
      {
        faqItem: 'Download a form',
        [DEV]:
          'https://www.alaska529plan.com/account-holder.html#account-holder-forms',
        [PROD]:
          'https://www.alaska529plan.com/account-holder.html#account-holder-forms',
        [STAGE]:
          'https://www.alaska529plan.com/account-holder.html#account-holder-forms',
        product: '529 Plan',
        subject: 'Forms'
      }
    ]
  },
  '80': {
    'Tax Information and Forms': [
      {
        faqItem: 'View the tax form mailing schedule',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View or print your tax forms',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/statements',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/statements',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/statements',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Learn why you may or may not receive a tax form',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View the tax summary for your account',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/taxes',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/taxes',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/taxes',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Visit our Tax Planning Center',
        [DEV]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View other FAQs about taxes',
        [DEV]:
          'https://wwwdev.troweprice.com/personal-investing/troweprice-529/frequently-asked-questions.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/troweprice-529/frequently-asked-questions.html',
        [STAGE]:
          'https://wwwstage.troweprice.com/personal-investing/troweprice-529/frequently-asked-questions.html',
        product: '529 Plan',
        subject: 'Tax Information and Forms'
      }
    ],
    Transactions: [
      {
        faqItem: 'Contribute to a 529 portfolio',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/college/contribute',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/college/contribute',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/college/contribute',
        product: '529 Plan',
        subject: 'Transactions'
      },
      {
        faqItem: 'Take a distribution from a 529 portfolio',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/college/distribute',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/college/distribute',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/college/distribute',
        product: '529 Plan',
        subject: 'Transactions'
      },
      {
        faqItem: 'Set up automatic transactions',
        [DEV]: 'https://wwwdev.troweprice.com/usis/transactions/automatic',
        [PROD]: 'https://www.troweprice.com/usis/transactions/automatic',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/transactions/automatic',
        product: '529 Plan',
        subject: 'Transactions'
      },
      {
        faqItem: 'Qualified distribution or education expense',
        [DEV]:
          'https://wwwdev.troweprice.com/personal-investing/troweprice-529/approved-uses.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/troweprice-529/approved-uses.html',
        [STAGE]:
          'https://wwwstage.troweprice.com/personal-investing/troweprice-529/approved-uses.html',
        product: '529 Plan',
        subject: 'Transactions'
      }
    ],
    'Update Account Information': [
      {
        faqItem: 'Update Paperless Preferences online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/document-delivery',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/document-delivery',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/document-delivery',
        product: '529 Plan',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Change your password online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [PROD]:
          'https://www.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        product: '529 Plan',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Add/Update Bank information online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        product: '529 Plan',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Update your address online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/contact-information',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/contact-information',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/contact-information',
        product: '529 Plan',
        subject: 'Update Account Information'
      }
    ],
    Forms: [
      {
        faqItem: 'Download a form',
        [DEV]:
          'https://wwwdev.troweprice.com/personal-investing/troweprice-529/forms-and-documents.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/troweprice-529/forms-and-documents.html',
        [STAGE]:
          'https://wwwstage.troweprice.com/personal-investing/troweprice-529/forms-and-documents.html',
        product: '529 Plan',
        subject: 'Forms'
      }
    ]
  },
  '120': {
    Fees: [
      {
        faqItem: 'Fees and Minimums',
        [DEV]:
          'https://wwwdev.troweprice.com/personal-investing/advice/activeplus-portfolios/index.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice/activeplus-portfolios/index.html',
        [STAGE]:
          'https://wwwstage.troweprice.com/personal-investing/advice/activeplus-portfolios/index.html',
        product: 'ACTIVE_ADVISORY',
        subject: 'Fees'
      }
    ],
    RMD_SUBJECT: [
      {
        faqItem: 'View your automatic IRA withdrawal agreement',
        [DEV]: 'https://wwwdev.troweprice.com/usis/transactions/automatic',
        [PROD]: 'https://www.troweprice.com/usis/transactions/automatic',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/transactions/automatic',
        product: 'ACTIVE_ADVISORY',
        subject: RMD_SUBJECT
      },
      {
        faqItem:
          'Update your tax withholding election on your automatic IRA withdrawal agreement',
        [DEV]: 'https://wwwdev.troweprice.com/usis/transactions/automatic',
        [PROD]: 'https://www.troweprice.com/usis/transactions/automatic',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/transactions/automatic',
        product: 'ACTIVE_ADVISORY',
        subject: RMD_SUBJECT
      },
      {
        faqItem: 'Visit our RMD Learning Center',
        [DEV]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/retirement-planning/living-in-retirement/rmds.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/retirement-planning/living-in-retirement/rmds.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/retirement-planning/living-in-retirement/rmds.html',
        product: 'ACTIVE_ADVISORY',
        subject: RMD_SUBJECT
      },
      {
        faqItem: 'View your RMD calculation',
        [DEV]: 'https://www.troweprice.com/usis/rmd-tool/',
        [PROD]: 'https://www.troweprice.com/usis/rmd-tool/',
        [STAGE]: 'https://www.troweprice.com/usis/rmd-tool/',
        product: 'ACTIVE_ADVISORY',
        subject: RMD_SUBJECT
      }
    ],
    Forms: [
      {
        faqItem: 'Visit the Forms & Literature page',
        [DEV]: 'https://www.troweprice.com/personal-investing/forms.html',
        [PROD]: 'https://www.troweprice.com/personal-investing/forms.html',
        [STAGE]: 'https://www.troweprice.com/personal-investing/forms.html',
        product: 'ACTIVE_ADVISORY',
        subject: 'Forms'
      }
    ],
    'Individual Retirement Account (IRA)': [
      {
        faqItem: 'IRA Contribution History',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/taxes',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/taxes',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/taxes',
        product: 'ACTIVE_ADVISORY',
        subject: 'Individual Retirement Account (IRA)'
      },
      {
        faqItem: "IRA Limits & Other FAQ's",
        [DEV]:
          'https://www.troweprice.com/personal-investing/retirement/ira.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/retirement/ira.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/retirement/ira.html',
        product: 'ACTIVE_ADVISORY',
        subject: 'Individual Retirement Account (IRA)'
      }
    ],
    'Tax Information and Forms': [
      {
        faqItem: 'View the tax form mailing schedule',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/prepare-your-taxes/tax-information-mailing-schedule.html',
        product: 'ACTIVE_ADVISORY',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View or print your tax forms',
        [DEV]: 'https://wwwdev.troweprice.com/usis/my-accounts/statements',
        [PROD]: 'https://www.troweprice.com/usis/my-accounts/statements',
        [STAGE]: 'https://wwwstage.troweprice.com/usis/my-accounts/statements',
        product: 'ACTIVE_ADVISORY',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Learn why you may or may not receive a tax form',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes/tax-and-ira-frequently-asked-questions.html#link1',
        product: 'ACTIVE_ADVISORY',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'Visit our Tax Planning Center',
        [DEV]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/advice-and-planning/tax-planning.html',
        product: 'ACTIVE_ADVISORY',
        subject: 'Tax Information and Forms'
      },
      {
        faqItem: 'View other FAQs about taxes',
        [DEV]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/planning-and-research/tax-planning/learn-more-about-taxes.html',
        product: 'ACTIVE_ADVISORY',
        subject: 'Tax Information and Forms'
      }
    ],
    Transactions: [
      {
        faqItem: 'Learn how to rollover your IRA to T.\u00A0Rowe\u00A0Price',
        [DEV]:
          'https://www.troweprice.com/personal-investing/retirement/ira/rollover-and-transfer-ira.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/retirement/ira/rollover-and-transfer-ira.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/retirement/ira/rollover-and-transfer-ira.html',
        product: 'ACTIVE_ADVISORY',
        subject: 'Transactions'
      },
      {
        faqItem: 'Learn about online trading limitations',
        [DEV]:
          'https://www.troweprice.com/personal-investing/help/transactions.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/help/transactions.html',
        [STAGE]:
          'https://www.troweprice.com/personal-investing/help/transactions.html',
        product: 'ACTIVE_ADVISORY',
        subject: 'Transactions'
      },
      {
        faqItem: 'Add money into an ActivePlus Portfolio',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/advisory/add',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/advisory/add',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/advisory/add',
        product: 'ACTIVE_ADVISORY',
        subject: 'Transactions'
      },
      {
        faqItem: 'Withdraw money from an ActivePlus Portfolio',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/transactions/advisory/withdraw',
        [PROD]:
          'https://www.troweprice.com/usis/transactions/advisory/withdraw',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/transactions/advisory/withdraw',
        product: 'ACTIVE_ADVISORY',
        subject: 'Transactions'
      },
      {
        faqItem: 'Qualified Charitable Distributions (QCDs)',
        [DEV]:
          'https://www.troweprice.com/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf',
        [PROD]:
          'https://www.troweprice.com/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf',
        [STAGE]:
          'https://www.troweprice.com/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf',
        product: 'ACTIVE_ADVISORY',
        subject: 'Transactions'
      }
    ],
    'Update Account Information': [
      {
        faqItem: 'Change Beneficiary information online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/beneficiaries',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/beneficiaries',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/beneficiaries',
        product: 'ACTIVE_ADVISORY',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Update Paperless Preferences online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/document-delivery',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/document-delivery',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/document-delivery',
        product: 'ACTIVE_ADVISORY',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Change your password online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [PROD]:
          'https://www.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=https://www.troweprice.com/usis/my-accounts/profile',
        product: 'ACTIVE_ADVISORY',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Add/Update Bank information online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/linked-bank-accounts',
        product: 'ACTIVE_ADVISORY',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Change your name',
        [DEV]:
          'https://wwwdev.troweprice.com/content/dam/iinvestor/Forms/namechange.pdf',
        [PROD]:
          'https://www.troweprice.com/content/dam/iinvestor/Forms/namechange.pdf',
        [STAGE]:
          'https://wwwstage.troweprice.com/content/dam/iinvestor/Forms/namechange.pdf',
        product: 'ACTIVE_ADVISORY',
        subject: 'Update Account Information'
      },
      {
        faqItem: 'Update your address online',
        [DEV]:
          'https://wwwdev.troweprice.com/usis/my-accounts/profile/contact-information',
        [PROD]:
          'https://www.troweprice.com/usis/my-accounts/profile/contact-information',
        [STAGE]:
          'https://wwwstage.troweprice.com/usis/my-accounts/profile/contact-information',
        product: 'ACTIVE_ADVISORY',
        subject: 'Update Account Information'
      }
    ],
    'Life Events': [
      {
        faqItem:
          'Learn about life events and how they may impact your investing strategy',
        [DEV]:
          'https://wwwdev.troweprice.com/personal-investing/resources/planning/life-events/index.html',
        [PROD]:
          'https://www.troweprice.com/personal-investing/resources/planning/life-events/index.html',
        [STAGE]:
          'https://wwwstage.troweprice.com/personal-investing/resources/planning/life-events/index.html',
        product: 'ACTIVE_ADVISORY',
        subject: 'Life Events'
      }
    ]
  }
};
